module.exports = __webpack_public_path__ + "img/pcbpic.e280bbcc.jpg";